(function () {
  'use strict';

  var SELECTOR = '[data-rvrn-faq]';

  function initSection(section) {
    if (section.dataset.rvrnInit) return;
    section.dataset.rvrnInit = 'true';

    var items = Array.prototype.slice.call(section.querySelectorAll('.rvrn-faq__item'));
    if (!items.length) return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (section) initSection(section);
  });
})();
